(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('treeViewItem', treeViewItem);

    function treeViewItem() {
        return {
            restrict: 'E',
            controller: treeViewItemCtrl,
            controllerAs: 'vm',
            scope: {
                item: '=',
                template: '=',
                handleClick: '=',
            },
            bindToController: true
        };
    }

    function treeViewItemCtrl($compile, $element, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.open = true;
            vm.toggle = function() {
                vm.open = !vm.open;
            };

            $element.html(vm.template);
            var cloneElem = $compile($element.contents())($scope);
            $scope.$on('destroy', function() {
                if (cloneElem != null) {
                    cloneElem.off();
                }
            });
        }
    }
})();
